import React from "react";
import ReactDOM from "react-dom/client";
import { hydrate } from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./contexts/UserContext";
import { BrowserRouter as Router } from "react-router-dom";

// Get the root element
const rootElement = document.getElementById("root");

// App component wrapper
const AppWrapper = (
  <React.StrictMode>
    <Router>
      <UserProvider>
        <App />
      </UserProvider>
    </Router>
  </React.StrictMode>
);

// Check if the page is prerendered by react-snap
if (rootElement.hasChildNodes()) {
  // Use hydrate for prerendered content
  hydrate(AppWrapper, rootElement);
} else {
  // Use render for normal development
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppWrapper);
}

// Measure performance (optional)
reportWebVitals();
